import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ThemeProvider } from "@fluentui/react";
import * as React from "react";
import * as ReactDOM from "react-dom";

/* global document, Office, module, require, console */

initializeIcons();

let isOfficeInitialized = false;

const title = "PORTEGO Task Pane Add-in";
const APP_VERSION = "1.0.2";
const ADDIN_DISABLED = false;

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <ThemeProvider>
        {ADDIN_DISABLED ? (
          <>Das Add-In wurde temporär deaktiviert.</>
        ) : (
          <Component title={title} isOfficeInitialized={isOfficeInitialized} />
        )}
      </ThemeProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
  console.log("Version: ", APP_VERSION);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
